/* L'Arte del Tessuto — PDP experience (parallax, lente, colori, taglia, look, recensioni, sticky) */
(function () {
  'use strict';
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia('(pointer: fine)').matches;
  var fmt = new Intl.NumberFormat(document.documentElement.lang || 'it-IT', { style: 'currency', currency: 'EUR' });

  /* ---------- dizionario stringhe (dalle locale del tema) ---------- */
  var I18N = window.LDT_I18N || {};
  function tr(group, key, fallback) {
    try { return (I18N[group] && I18N[group][key]) || fallback; } catch (e) { return fallback; }
  }
  function trf(group, key, fallback, args) {
    var s = tr(group, key, fallback);
    for (var i = 0; i < args.length; i++) { s = s.replace('%%s'.replace('%%', '%'), args[i]); }
    return s;
  }

  function money(c) { return fmt.format((c || 0) / 100); }
  function vh() { return window.innerHeight || 800; }

  /* ---------- selezione variante nel buy box ---------- */
  function pickOption(name, value) {
    var inputs = $$('variant-radios input[type="radio"], variant-selects input[type="radio"]');
    var hit = inputs.filter(function (i) { return i.name === name && i.value === value; })[0];
    if (!hit) {
      /* fallback: per posizione (1 = colore, 2 = taglia) */
      var sets = $$('variant-radios fieldset');
      var idx = name === 'Taglia' && sets.length > 1 ? 1 : 0;  /* con una sola opzione è la prima */
      if (sets[idx]) hit = $$('input[type="radio"]', sets[idx]).filter(function (i) { return i.value === value; })[0];
    }
    if (hit && !hit.checked) hit.click();
    return !!hit;
  }

  /* attende che il tema abbia finito di ri-renderizzare (il pulsante resta disabilitato
     per qualche centinaio di ms dopo il cambio variante) */
  function whenEnabled(fn, tries) {
    tries = tries || 0;
    var b = $('product-info .product-form__submit') || $('.product__info-container .product-form__submit');
    if (!b || !b.disabled || tries > 40) { fn(); return; }
    setTimeout(function () { whenEnabled(fn, tries + 1); }, 100);
  }
  function scrollToBuy() {
    var sec = $('[id^="MainProduct-"]') || $('.product');
    if (!sec) return;
    var y = sec.getBoundingClientRect().top + window.scrollY - 20;
    window.scrollTo({ top: Math.max(0, y), behavior: reduce ? 'auto' : 'smooth' });
  }
  function flash(msg) {
    var t = $('.pd-toast');
    if (!t) { t = document.createElement('div'); t.className = 'pd-toast'; document.body.appendChild(t); }
    t.innerHTML = msg; t.classList.add('is-on');
    clearTimeout(t._t); t._t = setTimeout(function () { t.classList.remove('is-on'); }, 2600);
  }


  /* ---------- legenda varianti: testo residuo del tema ("Taglia: MS") ---------- */
  function fixLegends() {
    $$('variant-radios legend').forEach(function (lg) {
      var sp = $('span[id^="selected-"]', lg); if (!sp) return;
      var stray = '';
      Array.prototype.slice.call(lg.childNodes).forEach(function (n) {
        if (n.nodeType === 3 && n.previousSibling === sp && n.textContent.trim()) { stray = n.textContent.trim(); n.textContent = ''; }
      });
      var fs = lg.closest('fieldset'); var ck = fs && $('input[type="radio"]:checked', fs);
      var want = ck ? ' ' + ck.value : (sp.textContent.trim() ? null : (stray ? ' ' + stray : null)); if (want && sp.textContent !== want) sp.textContent = want;
    });
  }
  fixLegends();
  document.addEventListener('change', function (e) { if (e.target.closest('variant-radios')) setTimeout(fixLegends, 60); });
  if (window.MutationObserver) { var vr = $('variant-radios'); if (vr) new MutationObserver(function () { clearTimeout(fixLegends._t); fixLegends._t = setTimeout(fixLegends, 30); }).observe(vr.parentNode, { childList: true, subtree: true }); }

  /* ---------- parallax / drift / zoom (rAF) ---------- */
  var par = $$('[data-pd-speed]'), drift = $$('[data-pd-drift]'), zooms = $$('[data-pd-zoom]');
  var ticking = false;
  function frame() {
    ticking = false;
    var h = vh();
    if (!reduce) {
      par.forEach(function (el) {
        if (window.innerWidth < 750 && !el.hasAttribute('data-pd-mobile')) { el.style.transform = ''; return; }
        var r = el.getBoundingClientRect(); if (r.bottom < -200 || r.top > h + 200) return;
        var c = r.top + r.height / 2 - h / 2;
        el.style.transform = 'translate3d(0,' + (c * parseFloat(el.getAttribute('data-pd-speed'))).toFixed(1) + 'px,0)';
      });
      drift.forEach(function (el) {
        var sec = el.closest('section') || el; var r = sec.getBoundingClientRect();
        if (r.bottom < 0 || r.top > h) return;
        var p = (h - r.top) / (h + r.height);
        el.style.transform = 'translate3d(' + ((p - .5) * parseFloat(el.getAttribute('data-pd-drift'))).toFixed(2) + '%,0,0)';
      });
      zooms.forEach(function (el) {
        var r = el.getBoundingClientRect(); if (r.bottom < 0 || r.top > h) return;
        var p = Math.min(1, Math.max(0, (h - r.top) / (h + r.height * .4)));
        el.style.transform = 'scale(' + (1.22 - p * .22).toFixed(3) + ')';
      });
    }
    stickyCheck();
  }
  function onScroll() { stickyCheck(); if (!ticking) { ticking = true; requestAnimationFrame(frame); } }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);

  /* ---------- count-up ---------- */
  if ('IntersectionObserver' in window) {
    var cio = new IntersectionObserver(function (es) {
      es.forEach(function (en) {
        if (!en.isIntersecting) return; cio.unobserve(en.target);
        var el = en.target, raw = el.getAttribute('data-pd-count'), n = parseFloat(raw);
        if (isNaN(n) || String(n) !== raw.trim() || reduce) return;
        var t0 = null, dur = 1400;
        function step(ts) { if (!t0) t0 = ts; var k = Math.min(1, (ts - t0) / dur); var e = 1 - Math.pow(1 - k, 3); el.textContent = Math.round(n * e); if (k < 1) requestAnimationFrame(step); }
        el.textContent = '0'; requestAnimationFrame(step);
      });
    }, { threshold: .6 });
    $$('[data-pd-count]').forEach(function (n) { cio.observe(n); });
  }

  /* ---------- lente sui dettagli ---------- */
  $$('[data-pd-spots]').forEach(function (sec) {
    var stage = $('[data-pd-spots-img]', sec), img = $('img', stage), loupe = $('.pd-loupe', stage);
    var dots = $$('.pd-dot', sec), items = $$('.pd-spot', sec), list = $('[data-pd-spots-list]', sec);
    var hd = stage.getAttribute('data-hd'); if (hd) loupe.style.backgroundImage = 'url("' + hd + '")';
    var cur = 0, auto = null, touched = false, hovering = false;
    function place(xp, yp, z) {
      var W = stage.clientWidth, H = stage.clientHeight, L = loupe.offsetWidth || 170;
      var bw = W * z, bh = H * z;
      loupe.style.left = (xp / 100 * W) + 'px'; loupe.style.top = (yp / 100 * H) + 'px';
      loupe.style.backgroundSize = bw + 'px ' + bh + 'px';
      loupe.style.backgroundPosition = (-(xp / 100 * bw - L / 2)) + 'px ' + (-(yp / 100 * bh - L / 2)) + 'px';
    }
    function activate(i, fromList) {
      cur = i;
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
      items.forEach(function (it, k) { it.classList.toggle('is-active', k === i); });
      var d = dots[i]; if (!d) return;
      place(+d.getAttribute('data-x'), +d.getAttribute('data-y'), +d.getAttribute('data-z') || 3);
      stage.classList.add('is-loupe');
      if (list && window.innerWidth < 990 && !fromList) {
        var it = items[i]; if (it) list.scrollTo({ left: it.offsetLeft - 20, behavior: reduce ? 'auto' : 'smooth' });
      }
    }
    function stop() { touched = true; clearInterval(auto); }
    dots.forEach(function (d, k) {
      d.addEventListener('click', function () { stop(); activate(k); });
      d.addEventListener('mouseenter', function () { if (fine) { stop(); activate(k); } });
    });
    items.forEach(function (it, k) {
      $('button', it).addEventListener('click', function () { stop(); activate(k, true); });
      it.addEventListener('mouseenter', function () { if (fine && window.innerWidth >= 990) { stop(); activate(k, true); } });
    });
    if (fine) {
      stage.addEventListener('mousemove', function (e) {
        if (e.target.closest('.pd-dot')) return;
        hovering = true; stop();
        var r = stage.getBoundingClientRect();
        place((e.clientX - r.left) / r.width * 100, (e.clientY - r.top) / r.height * 100, 2.6);
        stage.classList.add('is-loupe', 'is-free');
      });
      stage.addEventListener('mouseleave', function () { hovering = false; stage.classList.remove('is-free'); activate(cur); });
    }
    if (list) {
      var st;
      list.addEventListener('scroll', function () {
        if (window.innerWidth >= 990) return;
        clearTimeout(st); st = setTimeout(function () {
          var best = 0, bd = 1e9;
          items.forEach(function (it, k) { var dd = Math.abs(it.offsetLeft - 20 - list.scrollLeft); if (dd < bd) { bd = dd; best = k; } });
          if (best !== cur) { touched = true; clearInterval(auto); activate(best, true); }
        }, 90);
      }, { passive: true });
    }
    window.addEventListener('resize', function () { activate(cur, true); });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (en) {
          if (en.isIntersecting) {
            if (!stage.classList.contains('is-loupe')) activate(cur, true);
            if (!touched && !auto && !reduce) auto = setInterval(function () { if (!hovering) activate((cur + 1) % dots.length, window.innerWidth >= 990); }, 3600);
          } else { clearInterval(auto); auto = null; }
        });
      }, { threshold: .45 }).observe(stage);
    }
    if (img && !img.complete) img.addEventListener('load', function () { activate(cur, true); });
  });

  /* ---------- colori ---------- */
  $$('[data-pd-colors]').forEach(function (sec) {
    var cards = $$('.pd-color', sec);
    function act(c) { cards.forEach(function (x) { x.classList.toggle('is-active', x === c); }); }
    cards.forEach(function (c) {
      c.addEventListener('mouseenter', function () { if (fine && window.innerWidth >= 990) act(c); });
      c.addEventListener('focus', function () { act(c); });
      c.addEventListener('click', function () {
        if (window.innerWidth >= 990 && !c.classList.contains('is-active')) { act(c); return; }
        var v = c.getAttribute('data-color');
        if (pickOption('Colore', v)) { whenEnabled(function () { flash(tr('msg','color','Colore selezionato:') + ' <b>' + v + '</b>'); scrollToBuy(); }); }
      });
    });
  });

  /* ---------- trova la taglia ---------- */
  $$('[data-pd-size]').forEach(function (sec) {
    var range = $('[data-pd-size-range]', sec), rows = $$('tbody tr', sec), outs = $$('[data-pd-size-out]', sec);
    var val = $('[data-pd-size-val] b', sec), msg = $('[data-pd-size-msg]', sec), badge = $('.pd-finder__badge', sec);
    var chosen = null;
    function upd() {
      var v = +range.value, hit = null;
      rows.forEach(function (r) { var a = +r.getAttribute('data-min'), b = +r.getAttribute('data-max'); if (v >= a && v <= b) hit = r; });
      var first = rows[0], last = rows[rows.length - 1], note = '';
      if (!hit && first && v < +first.getAttribute('data-min')) { hit = first; note = ' È la più piccola disponibile.'; }
      if (!hit && last && v > +last.getAttribute('data-max')) { hit = last; note = ' È la più grande: scrivici per un consiglio.'; }
      rows.forEach(function (r) { r.classList.toggle('is-hit', r === hit); });
      var pct = (v - range.min) / (range.max - range.min) * 100;
      range.style.setProperty('--p', pct + '%');
      val.textContent = v;
      if (hit) {
        var s = hit.getAttribute('data-size');
        if (s !== chosen) { chosen = s; badge.classList.remove('is-pop'); void badge.offsetWidth; badge.classList.add('is-pop'); }
        outs.forEach(function (o) { o.textContent = s; });
        msg.innerHTML = tr('size','recommend','We recommend the <b>%s</b>.').replace('%s', s) + note;
      }
    }
    range.addEventListener('input', upd); upd();
    $('[data-pd-size-pick]', sec).addEventListener('click', function () {
      if (chosen && pickOption('Taglia', chosen)) { whenEnabled(function () { flash(tr('size','picked','Size selected:') + ' <b>' + chosen + '</b>'); scrollToBuy(); }); }
    });
  });
  /* link "Guida taglie" accanto alla taglia nel buy box */
  (function () {
    var sets = $$('variant-radios fieldset'); var target = $('#guida-taglie');
    if (sets.length < 2 || !target) return;
    var lg = $('legend', sets[1]); if (!lg || lg.parentNode.querySelector('.pd-sizelink')) return;
    var a = document.createElement('a'); a.href = '#guida-taglie'; a.className = 'pd-sizelink';
    a.innerHTML = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><path d="M3 8h18v8H3z"/><path d="M7 8v3M11 8v4M15 8v3M19 8v4"/></svg>' + tr('msg','sizeGuide','Trova la tua taglia');
    a.addEventListener('click', function (e) { e.preventDefault(); target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' }); });
    lg.parentNode.appendChild(a);
  })();


  /* ---------- pillole taglia (template generico, senza tabella misure) ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-pd-sizepick]'); if (!b) return;
    var v = b.getAttribute('data-pd-sizepick');
    if (pickOption('Taglia', v)) {
      $$('[data-pd-sizepick]').forEach(function (x) { x.classList.toggle('is-on', x === b); });
      whenEnabled(function () { flash(tr('size','picked','Size selected:') + ' <b>' + v + '</b>'); scrollToBuy(); });
    }
  });


  /* ---------- resilienza: se il tema non riesce ad aggiornare la scheda (AJAX bloccata,
     dominio in errore), il pulsante resta disabilitato per sempre. Lo riabilitiamo:
     l'input variante è già aggiornato, quindi il POST porta il capo giusto nel carrello. */
  document.addEventListener('change', function (e) {
    if (!e.target.closest('variant-radios, variant-selects')) return;
    setTimeout(function () {
      var b = $('product-info .product-form__submit');
      if (b && b.disabled) {
        b.disabled = false;
        b.removeAttribute('aria-disabled');
        document.documentElement.classList.add('pd-atc-fallback');
      }
    }, 2600);
  });


  /* ---------- ATC di riserva: se il tema non riesce ad aggiornare la scheda
     (dominio in errore / AJAX bloccata) gestiamo noi l'aggiunta ---------- */
  document.addEventListener('submit', function (e) {
    if (!e.target.closest('product-form')) return;
    if (!document.documentElement.classList.contains('pd-atc-fallback')) return;
    var form = e.target;
    var idEl = form.querySelector('input[name="id"]');
    if (!idEl || !idEl.value) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var qEl = form.querySelector('input[name="quantity"], select[name="quantity"]');
    var qty = qEl ? parseInt(qEl.value, 10) || 1 : 1;
    var btn = form.querySelector('.product-form__submit');
    if (window.LDT_BW_add) { window.LDT_BW_add([{ id: +idEl.value, quantity: qty }], btn); }
    else {
      btn && btn.classList.add('is-loading');
      fetch('/cart/add.js?_fd=0', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +idEl.value, quantity: qty }] }) })
        .then(function (r) { return r.json(); }).then(function () { window.location.href = '/cart'; });
    }
  }, true);

  /* ---------- completa il look ---------- */
  $$('[data-ldt-look]').forEach(function (sec) {
    var items = $$('[data-pd-item]', sec), fill = $('[data-pd-tiers-fill]', sec), steps = $$('[data-step]', sec);
    function calc() {
      var n = 0, sum = 0, was = 0;
      items.forEach(function (it) {
        var on = $('[data-pd-inc]', it).checked;
        it.classList.toggle('is-off', !on);
        if (on) { it.setAttribute('data-bw-item', ''); n++; sum += +it.getAttribute('data-price'); was += +it.getAttribute('data-compare'); }
        else it.removeAttribute('data-bw-item');
        var t = $('[data-pd-look-tile="' + it.getAttribute('data-idx') + '"]', sec); if (t) t.classList.toggle('is-off', !on);
      });
      var pct = n >= 3 ? 20 : n === 2 ? 10 : 0;
      var now = Math.round(sum * (100 - pct) / 100);
      $('[data-pd-look-count]', sec).textContent = n === 1 ? tr('look','count1','Il look · 1 capo') : tr('look','countN','Il look · %s capi').replace('%s', n);
      $('[data-pd-look-was]', sec).textContent = was > now ? money(was) : '';
      $('[data-pd-look-now]', sec).textContent = money(now);
      var save = $('[data-pd-look-save]', sec);
      save.textContent = pct ? tr('look','pct','-%s%% extra · risparmi %s').replace('%s', pct).replace('%s', money(sum - now)) : tr('look','noPct','Aggiungi un capo: -10% extra');
      save.classList.toggle('is-muted', !pct);
      $('[data-pd-look-pct]', sec).textContent = pct ? '-' + pct + '%' : '-10%';
      $('[data-pd-look-cta]', sec).textContent = n ? (n === 1 ? tr('look','add1','Aggiungi 1 capo · %s').replace('%s', money(now)) : tr('look','addN','Aggiungi %s capi · %s').replace('%s', n).replace('%s', money(now))) : tr('look','pickOne','Seleziona almeno un capo');
      if (fill) fill.style.width = (n <= 1 ? 8 : n === 2 ? 52 : 100) + '%';
      steps.forEach(function (s) { s.classList.toggle('is-on', +s.getAttribute('data-step') <= n); });
    }
    items.forEach(function (it) { $('[data-pd-inc]', it).addEventListener('change', calc); });
    sec.addEventListener('change', function (e) {
      var s = e.target.closest('select[data-opt="1"]'); if (!s) return;
      var it = s.closest('[data-pd-item]'); if (!it) return;
      setTimeout(function () {
        var im = $('img', it), t = $('[data-pd-look-tile="' + it.getAttribute('data-idx') + '"] img', sec);
        if (im && t) { t.src = im.src; t.removeAttribute('srcset'); }
      }, 30);
    });
    calc();
  });
  /* ---------- voci delle clienti ---------- */
  $$('[data-pd-quotes]').forEach(function (sec) {
    var qs = $$('.pd-quote', sec), bars = $$('[data-pd-qi]', sec), cur = 0, tm = null, DUR = 6500;
    if (qs.length < 2) return;
    function go(i) {
      cur = (i + qs.length) % qs.length;
      qs.forEach(function (q, k) { q.classList.toggle('is-active', k === cur); });
      bars.forEach(function (b, k) { b.classList.toggle('is-done', k < cur); b.classList.remove('is-run'); if (k === cur) { void b.offsetWidth; b.classList.add('is-run'); } });
      clearTimeout(tm); if (!reduce) tm = setTimeout(function () { go(cur + 1); }, DUR);
    }
    sec.style.setProperty('--pd-qdur', DUR + 'ms');
    $$('[data-pd-q]', sec).forEach(function (b) { b.addEventListener('click', function () { go(cur + +b.getAttribute('data-pd-q')); }); });
    bars.forEach(function (b) { b.addEventListener('click', function () { go(+b.getAttribute('data-pd-qi')); }); });
    var started = false;
    if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { es.forEach(function (en) { if (en.isIntersecting && !started) { started = true; go(0); } }); }, { threshold: .4 }).observe(sec);
    else go(0);
  });

  /* ---------- sticky add to cart: solo dopo il pulsante principale ---------- */
  /* il contenitore ha transform: lo porto nel body perché position:fixed funzioni */
  var stk = $('.sticky-atc'); if (stk && stk.parentElement !== document.body) document.body.appendChild(stk);
  var foot = $('footer') || $('.footer');
  function stickyCheck() {
    var mainBtn = $('product-info .product-form__submit') || $('.product__info-container .product-form__submit');
    if (!mainBtn) return;
    var past = mainBtn.getBoundingClientRect().bottom < 0;
    var nearFoot = foot ? foot.getBoundingClientRect().top < vh() - 40 : false;
    document.documentElement.classList.toggle('pd-sticky-on', past && !nearFoot);
  }
  document.documentElement.classList.add('pd-js');
  frame();
})();
